import generateIcon from "../generateIcon";

const Application = generateIcon("fas fa-address-card");

export default Application;